import { useTranslation } from 'react-i18next';
import TemplateGeneratorHeroBlock from '../components/FeatureBlocks/TemplateGeneratorBlocks/TemplateGeneratorHeroBlock';
import FeatureSignatureBlock from '../components/FeatureBlocks/FeatureSignatureBlock/FeatureSignatureBlock';
import FeatureTextBlock from '../components/FeatureBlocks/FeatureTextBlock/FeatureTextBlock';
import StepFeatureBlock from '../components/FeatureBlocks/StepFeatureBlock/StepFeatureBlock';
import TestimonialCarouselCardBlock from '../components/FeatureBlocks/TestimonialCarouselCardBlock/TestimonialCarouselCardBlock';
import FeatureIntegrationBlock from '../components/FeatureBlocks/FeatureIntegrationBlock/FeatureIntegrationBlock';
import PromoBlockLeft from '../components/FeatureBlocks/PromoBlockLeft/PromoBlockLeft';
import { usePromoCode } from '../hooks/usePromoCode';
import BellIcon from '../svg/bell.inline.svg';
import CheckCircleIcon from '../svg/check-circle.inline.svg';
import ClockIcon from '../svg/clock.inline.svg';
import TemplatesIcon from '../svg/templates.inline.svg';
import SparksIcon from '../svg/sparks.inline.svg';

import '../styles/online-template.scss';
import { GeneratedTemplateType } from '../types/util-types';
import VerticalFeatureBlock from '../components/FeatureBlocks/VerticalFeaturesBlock/VerticalFeatureBlock';

// Reuse the step blocks from the original contract page
const stepBlocksOne = [
    {
        subTransId: 'browse',
        iconSVG: <TemplatesIcon />,
        imageUrl:
            'marketing_site/online-contracts/templates/desktop/v2/Browse_legally-vetted_templates.png'
    },
    {
        subTransId: 'autoFill',
        iconSVG: <SparksIcon />,
        imageUrl:
            'marketing_site/online-contracts/templates/desktop/v2/Auto-fill_client_details.png'
    }
];

const stepBlocksTwo = [
    {
        subTransId: 'schedule',
        iconSVG: <ClockIcon />,
        imageUrl:
            'marketing_site/online-contracts/templates/desktop/v2/Send_at_the_perfect_moment.png'
    },
    {
        subTransId: 'clientSuccess',
        iconUrl: 'marketing_site/online-contracts/templates/Team_avatars.png',
        imageUrl:
            'marketing_site/online-contracts/templates/desktop/v2/Manage_client_access.png'
    }
];

const stepBlocksThree = [
    {
        subTransId: 'statusUpdates',
        iconSVG: <CheckCircleIcon />,
        imageUrl:
            'marketing_site/online-contracts/templates/desktop/v2/Receive_status_updates.png'
    },
    {
        subTransId: 'reminders',
        iconSVG: <BellIcon />,
        imageUrl:
            'marketing_site/online-contracts/templates/desktop/v2/Automate_gentle_reminders.png'
    }
];

const signatureCardContents = [
    {
        iconUrl: 'marketing_site/online-contracts/signature/Signature.svg',
        transId: 'effortless'
    },
    {
        iconUrl: 'marketing_site/online-contracts/signature/Phone.svg',
        transId: 'onTheGo'
    },
    {
        iconUrl: 'marketing_site/online-contracts/signature/Stars.svg',
        transId: 'impression'
    }
];

function IntentSpecificContract(): JSX.Element {
    const { t } = useTranslation();
    const { promoCode } = usePromoCode();

    const linkTransKey = 'linkText';
    const transKey = `stepsFeatureBlock.${linkTransKey}`;

    return (
        <div className="online-template online-template--intent-specific-contract">
            <TemplateGeneratorHeroBlock
                title={t('templateGeneratorHeroBlock.title')}
                subtitle={t('templateGeneratorHeroBlock.subtitle')}
                templateType={GeneratedTemplateType.CONTRACT}
            />
            <VerticalFeatureBlock
                templateType={GeneratedTemplateType.CONTRACT}
            />
            <FeatureSignatureBlock
                cardContents={signatureCardContents}
                ctaSource="contract signature block"
            />
            <FeatureTextBlock
                title={t('featureTextBlock.title')}
                imageUrl="marketing_site/online-contracts/Contract.png"
            />
            <StepFeatureBlock
                transId="stepsFeatureBlock.step1"
                stepSubBlocks={stepBlocksOne}
                linkText={t(transKey)}
            />
            <StepFeatureBlock
                reverse
                transId="stepsFeatureBlock.step2"
                stepSubBlocks={stepBlocksTwo}
                linkText={t(transKey)}
            />
            <StepFeatureBlock
                transId="stepsFeatureBlock.step3"
                stepSubBlocks={stepBlocksThree}
                linkText={t(transKey)}
            />
            <TestimonialCarouselCardBlock hideStarReviews={true} />
            <FeatureIntegrationBlock
                title={t('featureIntegrationBlock.title')}
                subtitle={t('featureIntegrationBlock.subtitle')}
            />
            <PromoBlockLeft
                customClass="verticals-paid-page--new__promo-block-left promo-block-left--yellow"
                title={t(`${promoCode}.promoBlockLeft.title`)}
                subtitle={t(`${promoCode}.promoBlockLeft.subtitle`, {
                    defaultValue: null
                })}
                source="promo block left - yellow"
                promoCode={promoCode}
            />
        </div>
    );
}

export default IntentSpecificContract;
